import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ProductClassSelect } from 'adminDashboard/benefitDetails/common/productClassSelect'
import { Formik } from 'formik'
import * as Yup from 'yup'

import { BenefitProductClassResponse, SaveIchraProductClassRequest, saveIchraProductClass } from 'core'

import { Button, Card, Icon, Tooltip } from 'common/components'
import { useCommandRequestV2 } from 'common/hooks'

import './styles.less'

type SaveProductClassFormProps = {
  initialValues: FormProps
  productClasses: BenefitProductClassResponse[]
  onProductClassSaved?: (id: string) => void
  onProductClassCancel?: any
}

export type FormProps = {
  planPeriodId: string
  classTypeIds: number[]
  id?: string
  stateId?: string
  name?: string
}

const StateCheckBoxValue = -1

export const SaveProductClassForm = (props: SaveProductClassFormProps) => {
  const { t: translate } = useTranslation()
  const { sendCommand: sendSaveProductClass, isLoading: isSaveProductClassLoading } = useCommandRequestV2<string>(
    (request: SaveIchraProductClassRequest) => saveIchraProductClass(request),
  )

  const onSubmit = async (values: FormProps) => {
    const result = await sendSaveProductClass({
      productClassId: props.initialValues.id,
      classTypeIds: values.classTypeIds,
      stateId: values.stateId,
      planPeriodId: props.initialValues.planPeriodId,
    })

    if (result.completed && props.onProductClassSaved) {
      props.onProductClassSaved(result.data)
    }
  }

  const [initialValues] = useState<any>({
    classTypeIds: props.initialValues.classTypeIds ?? [],
    stateId: props.initialValues.stateId,
  })

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={formValidator(translate)}
      initialValues={initialValues}
      onSubmit={async () => {}}
    >
      {(formik) => {
        return (
          <Card
            className={'ichra-save-product-class-form'}
            title={props.initialValues.id ? `Edit ${props.initialValues.name}` : 'Add Class'}
            style={{ border: '1px dashed lightgrey' }}
            extra={<Icon className={'fas fa-times mt-8'} onClick={props.onProductClassCancel} />}
            actions={[
              <div className={'float-right '}>
                <Button onClick={props.onProductClassCancel} disabled={isSaveProductClassLoading} className={'mr-8'}>
                  Cancel
                </Button>

                <Tooltip
                  title={
                    !formik.values.classTypeId &&
                    translate('admin-dashboard.benefit-details.perks-benefit-create-eligible-classes.save-tooltip')
                  }
                >
                  <Button
                    type="primary"
                    onClick={async () => await onSubmit(formik.values)}
                    loading={isSaveProductClassLoading}
                    disabled={isSaveProductClassLoading || !formValidator(translate).isValidSync(formik.values)}
                    className={'mr-8'}
                  >
                    Save
                  </Button>
                </Tooltip>
              </div>,
            ]}
          >
            <ProductClassSelect />
          </Card>
        )
      }}
    </Formik>
  )
}

const formValidator = (translate: any) =>
  Yup.object({
    classTypeIds: Yup.array().required(translate('required')),
    stateId: Yup.string()
      .nullable()
      .when('classTypeIds', {
        is: (classTypeIds: number[]) => classTypeIds.includes(StateCheckBoxValue),
        then: Yup.string().required(translate('required')),
      }),
  })
